export default __webpack_public_path__ + "static/media/entypo_emoji-happy.7a29164f.svg";